interface IGreyActionButtonProps {
    label: string
    onClick?: () => void
    disabled?: boolean
}

export const GreyActionButton = (props: IGreyActionButtonProps) => {
    const disabled = !!props.disabled
    const classes = `mt-3 rounded-lg bg-mediaBackground px-3 py-3 text-base w-fit flex flex-row items-center ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`
    const handleClick = () => {
        if (disabled) return
        props.onClick?.()
    }
    return (
        <div
          role="button"
          aria-disabled={disabled}
          onClick={handleClick}
          className={classes}
        >
          <div className={'text-base'}>{props.label}</div>
        </div>
    )
}